export var getCardsConfig = function (_a) {
    var screenType = _a.screenType;
    return screenType === 'mobile'
        ? [
            { colSize: 2, id: 'card1' },
            { colSize: 1, id: 'card2' },
        ]
        : [
            { colSize: 2, id: 'card1' },
            { colSize: 1, id: 'card2' },
            { colSize: 1, id: 'card3' },
            { colSize: 1, id: 'card4' },
            { colSize: 1, id: 'card5' },
            { colSize: 2, id: 'card6' },
        ];
};
